export default "/_next/static/0d34549abdbb8cc3f00f2a65b5a38e55.jpg";